<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Distribution</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col32 marginColBottom">
        <div class="destDistribuicao">
          <div style="margin:0 0 20px 0;">
            <span class="titDestDist">important agreements signed with</span>
            <ul>
              <li>AMAZON VIDEO</li>
              <li>FACEBOOK</li>
              <li>GOOGLE PLAY MUSIC</li>
              <li>TIM MUSIC BY DEEZER</li>
              <li>ABRAPLEX</li>
            </ul>
          </div>
          <div class="subDestDistribuicao">
            <div>
              <span class="titDestDist">agreement<br />
                    renewed with
              </span>
              <span class="DestDestDist1">
                GRUPO 
                GLOBO
              </span>
            </div>
            <div>
              <span class="titDestDist">including digital<br />
                    platforms
              </span>
              <span class="DestDestDist2">
                TELECINE PLAY, 
                GLOBOPLAY, 
                PHILOS TV
                AND OTHERS
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col40ponto4">
        <p class="ptreze">The total amount distributed by UBC in 2018 was BRL 524.3 million. 186,000 national and international members received funds, a 25% increase compared to the previous year.</p>
        <br />
        <p class="ptreze">Amounts distributed in the most recent biennium (2018, 2017) rose 61.9% compared to the previous biennium (2016, 2015). However, the 2018 distribution dropped 13.3% compared to 2017.</p>
        <br />
        <p class="ptreze">Amounts distributed to UBC members represented 57% of the total amount distributed by ECAD.</p>
        <br />
        <p class="ptreze">Royalties pertaining to cinema are worth highlighting, as they presented the largest growth rate – a significant 504% rise compared to 2017. In 2018, they represented 7.4% of the total distribution. This growth is in large part due to the agreement signed with ABRAPLEX – the Brazilian Association of Multiplex Cinema Operator Companies. Royalties pertaining to the internet maintain their accelerated growth rate (48.6%), representing 8.3% of the total amount distributed. Highlights include the YouTube royalty distrubution and those distributed via new agreements signed with Amazon Video and Facebook. New contracts signed in 2018 with Google Play Music and Tim Music by Deezer will begin to show results in the coming years. </p>
        <br />
        <p class="ptreze">Royalties pertaining to broadcasting and radio broadcasting (Free-to-air TV, Pay TV and radio) represented 53.7% of total distribution.</p>
      </div><!-- col40ponto4 -->
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col36 marginColBottom">
        <span class="titGraf2">Total UBC distribution // In millions of (BRL)
        </span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_01.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col36">
        <span class="titGraf2">&nbsp;</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_02.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col36 marginColBottom">
        <span class="titGraf2">Distribution by type of rights holder // Public performance of musical works and recordings in Brazil</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_03.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col36">
        <span class="titGraf2">Distribution by payment source // Public performance of musical works and recordings in Brazil</span>
        <div style="width:100%; padding:50px 0 0 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_04.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
    </section>
    <section class="sectionRow" style="margin:60px 0 0 0;">
      <div class="col23ponto5"></div> 
      <div class="col40ponto4">
        <span class="titGraf2">Evolution of payment sources // Public performance of musical works and recordings in Brazil</span>
        <div style="width:100%; padding:50px 0 80px 0;">
            <video style="width:100%;" playsinline autoplay muted>
              <source src="../assets/grafico_distribuicao_05.mp4" type="video/mp4"> 
              Your browser does not support HTML5 video.
            </video>
          </div>
      </div>
      <div class="col32">
        </div>
    </section>
  </div>  
</div>
</template>

<script>
export default {
  name: 'Distribuicao',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Distribuicao.vue